// deprecated - use EshopFulltextAutocomplete component!
var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'fulltextAutocomplete';

var	DEFAULTS = {
	querySelector: '#query'	,
	categorySelector: '#category',
	url: null,
	timerMilliseconds: 400,
	lang: 'en',
	messages: {
		cs: {
			more: 'Zobrazit všechny výsledky'
		},
		en: {
			more: 'Show all results'
		}
	}
};

/**
 *
 * @param selector
 * @param options
 * @constructor
 */
var FulltextAutocomplete = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

/**
 *
 * @private
 */
FulltextAutocomplete.prototype.initialise_ = function() {

	if (!this.options.url || this.options.url == '') {
		return false;
	}

	this.i18n = this.options.messages[this.options.lang];

	this.$categoryInput = $(this.options.categorySelector, this.$t);
	this.$queryInput = $(this.options.querySelector, this.$t);

	this.keyUpTimer = null;
	this.$renderedResult = null;
	this.valBeforeKeyPress = '';
	this.selectedItem = -1;

	this.$queryInput.attr('autocomplete', 'off');

	this.hasCategorySelect = this.$categoryInput instanceof $;

	this.bindTextEntering_();
	this.bindSubmit_();

};

FulltextAutocomplete.prototype.bindSubmit_ = function() {
  var self_ = this;

  self_.$t.submit(function (event) {

    if (typeof(Turbolinks) != 'undefined') {
      var post_url = $(this).attr("action");
      var request_method = $(this).attr("method");
      var form_data = $(this).serialize();
      var xhr = new XMLHttpRequest();


      event.preventDefault();
      $.ajax({
        url: post_url,
        type: request_method,
        data: form_data,
        xhr: function () {
          return xhr;
        },
        success: function () {
          Turbolinks.visit(xhr.responseURL);
        }
      });
    }
  });

};

/**
 * bind keyup akce - psaní textu do query inputu
 * @private
 */
FulltextAutocomplete.prototype.bindTextEntering_ = function() {

	var self_ = this;

	this.$queryInput.on('keyup.fa_', function(e) {

		clearTimeout(self_.keyUpTimer);
		var val = $(e.currentTarget).val();

		if (val.length < 2) {
			self_.removeAutocompleteResult_();
			return false;
		}

		if (self_.valBeforeKeyPress == val) return false;

		self_.keyUpTimer = setTimeout(function() {
			self_.performSearch_(val);
		}, self_.options.timerMilliseconds);

	});

};

/**
 * samotné vyhledání dotazu - AJAX
 * @param query
 * @private
 */
FulltextAutocomplete.prototype.performSearch_ = function(query) {
	var self_ =  this;
	this.$t.addClass('fa-loading');

	var searchData = { query: query };

	if (this.hasCategorySelect && this.$categoryInput.val() && this.$categoryInput.val() != '') {
		searchData.category =  this.$categoryInput.val()
	}

	$.ajax({
		url: this.options.url,
		data: searchData,
		method: 'GET',
		cache: false
	}).done(function(data) {
		if (data && data.length > 0) {
			self_.renderResults_(data);
			const autocompleteTitle = $('.page-header .fulltext-autocomplete__title');
			if (autocompleteTitle.length > 0) {
				let ariaText = '';
				autocompleteTitle.each(function(index) {
					if (index > 0) ariaText += ', ';
					ariaText += $(this).text();
				});
				$('.page-header #query').attr('aria-label',ariaText).click();
			}
			const showMore = $('.fulltext-autocomplete-link-container').eq(0).clone();
			$('.fulltext-autocomplete-link-container').remove();
			showMore.appendTo('#resultAutocomplete');

		} else {
			self_.removeAutocompleteResult_();
			$('.page-header #query').removeAttr('aria-label');
		}
	});
};

FulltextAutocomplete.prototype.renderResults_ = function(data) {
	this.selectedItem = -1;
	this.removeAutocompleteResult_();

	this.$t.removeClass('fa-loading');
	this.$renderedResult = $(data).insertAfter(this.$queryInput);

	if (this.$renderedResult.find('li').length == 0) {
		this.$renderedResult.addClass('hidden');
	}
	else {
		this.$renderedResult.removeClass('hidden');
	}

	this.renderMoreLink_();

	this.bindAutocompleteResultEvents_();
};

FulltextAutocomplete.prototype.renderMoreLink_ = function() {
	var products = this.$renderedResult.find('.fulltext-autocomplete-product-list li').length;
	var categories = this.$renderedResult.find('.fulltext-autocomplete-category-list li').length;

	if ((products == 10) || (categories == 10)) {
		this.$renderedResult.append('<ul class="fulltext-autocomplete__list fulltext-autocomplete__list--more fulltext-autocomplete-list fulltext-autocomplete-more"><li class="fulltext-autocomplete__item"><a href="#" class="fulltext-autocomplete__link"> ' + this.i18n.more + '</a></li></ul>');
	}
};


/**
 * removes rendered resuts, if any
 * @private
 */
FulltextAutocomplete.prototype.removeAutocompleteResult_ = function() {
	if (this.$renderedResult &&  this.$renderedResult instanceof $) {
		this.$renderedResult.remove();
	}
	this.selectedItem = -1;
};

FulltextAutocomplete.prototype.bindAutocompleteResultEvents_ = function() {

	var self_ = this;
	this.$queryInput.off('keydown.ta_').on('keydown.ta_', function(e) {

		self_.valBeforeKeyPress = self_.$queryInput.val();

		if ((self_.$renderedResult instanceof $)) {
			var liCnt = $('li', self_.$renderedResult).length;
			// down
			if (e.keyCode == 40) {
				e.preventDefault();
				if (self_.selectedItem < liCnt-1) {
					self_.selectedItem++;
				}
			}

			// up
			if (e.keyCode == 38) {
				e.preventDefault();
				if (self_.selectedItem > 0) {
					self_.selectedItem--;
				}
			}

			//enter
			if (e.keyCode == 13) {

				if (self_.selectedItem > -1 && self_.selectedItem < $('li', self_.$renderedResult).length) {
				  e.preventDefault();
					$('li:eq('+self_.selectedItem+') > a', self_.$renderedResult)[0].click();
				} else {
					self_.removeAutocompleteResult_();

/*          self_.$t.ajaxSubmit({
           url: self_.$t.attr('action'),
           type: self_.$t.attr('method'),
            success: function() {
             console.log('callBack');
              Turbolinks.visit(self_.$t.attr('action'));
            }
          });*/
				}
			}

			//escape
			if (e.keyCode == 27) {
				e.preventDefault();
				self_.$queryInput.val('');
				self_.removeAutocompleteResult_();
			}

			$('li', self_.$renderedResult).removeClass('active');
			if (self_.selectedItem > -1) {
				$('li:eq('+self_.selectedItem+')', self_.$renderedResult).addClass('active');
			}
		}
	});
	/*
	* As per https://ep.fg.cz/issues/99290#change-745325
	* */
	$(this.$renderedResult).on('mouseover', 'li', function(e) {
		$('li', self_.$renderedResult).removeClass('active');
		$(e.currentTarget).addClass('active');
		// self_.selectedItem = $('li', self_.$renderedResult).index(e.currentTarget);
	});

	$(this.$renderedResult).on('click', 'li > a', function(e) {
		self_.performSelectAction_($(e.currentTarget), e);
	});
};

FulltextAutocomplete.prototype.performSelectAction_ = function($element, event) {
	if (!($element instanceof $)) {
		return false;
	}

	if ($element.attr('href') && $element.attr('href') !== '') {
		if ($element.parents('.fulltext-autocomplete-more').length > 0) {
		  event.preventDefault();
			this.$t.submit();
		}
	}
};
/**
 * decide, which methods will be "public"
 */
var API = {
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new FulltextAutocomplete(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/edeeshop/jquery.fulltextAutocomplete.js